import '@/style/index.scss'
import { VueQueryPlugin } from '@tanstack/vue-query'
import 'virtual:uno.css'
import { createSSRApp } from 'vue'
import App from './App.vue'
import { prototypeInterceptor, requestInterceptor, routeInterceptor } from './interceptors'
import i18n from './locale/index'
import store, { useGameStore } from './store'
import { getStorage, setStorage } from '@/utils/storage'
import storage from '@/local/storage'
import dayjs, { extend, locale } from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import updateLocale from 'dayjs/plugin/updateLocale'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/en'

// 设置语言
const language = getStorage(storage.LANGUAGE) || import.meta.env.VITE_APP_LANGUAGE
setStorage(storage.LANGUAGE, language)

// 配置 dayjs 插件
extend(utc)
extend(timezone)
extend(updateLocale)

// 获取用户时区
const getUserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Shanghai'
  } catch (error) {
    console.error('获取系统时区失败，使用默认时区：Asia/Shanghai')
    return 'Asia/Shanghai'
  }
}

// 初始化 dayjs 全局配置
const initDayjs = () => {
  // 设置语言
  locale(getStorage(storage.LANGUAGE) === 'zh-Hans' ? 'zh-cn' : 'en')

  // 设置北京时区
  // const userTimezone = getUserTimezone()
  dayjs.tz.setDefault('Asia/Shanghai')

  // 更新区域设置，确保时区正确应用
  dayjs.updateLocale(locale(), {
    meridiem: (hour: number) => (hour > 12 ? '下午' : '上午'),
  })

  console.log('Dayjs 初始化完成:', {
    语言: locale(),
    时区: 'Asia/Shanghai',
    当前时间: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    时区时间: dayjs().tz().format('YYYY-MM-DD HH:mm:ss'),
  })
}

window.addEventListener('DOMContentLoaded', function () {
  if (window.Telegram.WebApp) {
    Telegram.WebApp.expand() // 👈 让页面尝试进入全屏
  }
})

// 初始化 dayjs
initDayjs()

// 监听语言变化
uni.onLocaleChange(() => {
  const gameStore = useGameStore()
  const newLanguage = uni.getLocale()
  initDayjs()
  gameStore.updateGameCategoryList()
})

function hideLoadingCover() {
  const loadingCover = document.getElementById('loading-cover')
  console.log(loadingCover, '1111')
  if (loadingCover) {
    loadingCover.style.opacity = '0'
    loadingCover.style.transition = 'opacity 0.5s ease'
    setTimeout(() => loadingCover.remove(), 500)
  }
}

if (document.readyState === 'complete') {
  // 如果已经加载完毕，直接执行
  setTimeout(() => {
    hideLoadingCover()
  }, 5000)
} else {
  // 否则监听 load 事件
  window.addEventListener('load', hideLoadingCover)
}

export function createApp() {
  const app = createSSRApp(App)
  app.use(store)
  app.use(i18n)
  app.use(routeInterceptor)
  app.use(requestInterceptor)
  app.use(prototypeInterceptor)
  app.use(VueQueryPlugin)

  // 将 dayjs 挂载到全局，方便使用
  app.config.globalProperties.$dayjs = dayjs

  return {
    app,
  }
}
